<div
    style="padding: 20px; display: flex; align-items: center;  background: #0E0D0D; border-bottom: 1px solid #dedede;color: #dedede;">
    Manage Images of <span
        style="color: #dedede; background: #102c65; padding: 4px 12px; border-radius: 13px; font-size: 12px; margin-left: 10px;color: #dedede; ">{{data.packageProject.name}}</span>
</div>
<div style="padding: 20px;  font-size: 14px; display: flex;color: #dedede;background: #0E0D0D;">
    <mat-icon style="color: #3C50E0">info</mat-icon>
    <div style="margin-left: 10px">
        Note: <em>{{data.packageProject.name}}</em>&nbsp; is a house/townhouse/apartment built on the certain lots of
        <em>{{data.project.name}}</em>.<br>It can be viewed as a child
        project associated with <em>{{data.project.name}}</em>.
    </div>
</div>
<div style="max-height: 600px">
    <app-pictures [isPackage]="true" [project]="data.packageProject"></app-pictures>
</div>